import { c as _c } from "react/compiler-runtime";
import { cx } from 'class-variance-authority';
import { useTranslation } from 'react-i18next';
import CopyButton from '../copy-button';
export type CodeInlineProps = {
  ariaLabel?: string;
  children: string;
  disabled?: boolean;
  isPrivate?: boolean;
  size?: 'default' | 'compact';
  tooltip?: {
    position?: 'top' | 'bottom' | 'left' | 'right';
    text?: string;
    textConfirmation?: string;
  };
};
const CodeInline = t0 => {
  const $ = _c(28);
  const {
    ariaLabel,
    children,
    disabled,
    tooltip,
    isPrivate,
    size: t1
  } = t0;
  const size = t1 === undefined ? "default" : t1;
  const {
    t
  } = useTranslation("ui");
  if (disabled) {
    let t2;
    if ($[0] !== children || $[1] !== disabled || $[2] !== isPrivate || $[3] !== size) {
      t2 = <BaseCode size={size} disabled={disabled} isPrivate={isPrivate}>{children}</BaseCode>;
      $[0] = children;
      $[1] = disabled;
      $[2] = isPrivate;
      $[3] = size;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    return t2;
  }
  let t2;
  if ($[5] !== ariaLabel || $[6] !== t) {
    t2 = ariaLabel ?? t("components.code-inline.aria-label-default") as string;
    $[5] = ariaLabel;
    $[6] = t;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const t3 = tooltip?.position ?? "top";
  let t4;
  if ($[8] !== t || $[9] !== tooltip?.text) {
    t4 = tooltip?.text ?? t("components.code-inline.tooltip-text-default") as string;
    $[8] = t;
    $[9] = tooltip?.text;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t || $[12] !== tooltip?.textConfirmation) {
    t5 = tooltip?.textConfirmation ?? t("components.code-inline.tooltip-text-confirmation-default") as string;
    $[11] = t;
    $[12] = tooltip?.textConfirmation;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t3 || $[15] !== t4 || $[16] !== t5) {
    t6 = {
      position: t3,
      text: t4,
      textConfirmation: t5
    };
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== children || $[19] !== disabled || $[20] !== isPrivate || $[21] !== size) {
    t7 = <BaseCode size={size} disabled={disabled} isPrivate={isPrivate}>{children}</BaseCode>;
    $[18] = children;
    $[19] = disabled;
    $[20] = isPrivate;
    $[21] = size;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  let t8;
  if ($[23] !== children || $[24] !== t2 || $[25] !== t6 || $[26] !== t7) {
    t8 = <CopyButton className="max-md:min-w-0" contentToCopy={children} ariaLabel={t2} tooltip={t6}>{t7}</CopyButton>;
    $[23] = children;
    $[24] = t2;
    $[25] = t6;
    $[26] = t7;
    $[27] = t8;
  } else {
    t8 = $[27];
  }
  return t8;
};
const BaseCode = t0 => {
  const $ = _c(12);
  const {
    children,
    size,
    disabled: t1,
    isPrivate
  } = t0;
  const disabled = t1 === undefined ? false : t1;
  const t2 = !disabled;
  let t3;
  if ($[0] !== disabled || $[1] !== t2) {
    t3 = cx("inline-flex flex-wrap flex-grow-0 px-1 py-0.5", "rounded-sm", "bg-secondary", "border border-primary text-primary", "max-w-full w-fit max-md:min-w-0", {
      "cursor-default": disabled,
      "cursor-pointer": t2
    });
    $[0] = disabled;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = size === "compact";
  const t5 = isPrivate ? "mask" : undefined;
  let t6;
  if ($[3] !== t4 || $[4] !== t5) {
    t6 = cx("max-w-full text-snippet-2 truncate overflow-hidden text-ellipsis", {
      "text-snippet-3": t4,
      "data-dd-privacy": t5
    });
    $[3] = t4;
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== children || $[7] !== t6) {
    t7 = <code className={t6}>{children}</code>;
    $[6] = children;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t3 || $[10] !== t7) {
    t8 = <span className={t3}>{t7}</span>;
    $[9] = t3;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  return t8;
};
export default CodeInline;